
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/sales-process",
      function () {
        return require("private-next-pages/features/sales-process.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/sales-process"])
      });
    }
  